<div
  class="container relative max-w-(--breakpoint-xl)"
  [ngClass]="{
    'lg:max-[1870px]:pr-40!': drawerOutlet.isActivated,
  }">
  <router-outlet data-testid="content" />
</div>
<router-outlet #drawerOutlet="outlet" name="drawer" />
